<template>
  <div>
    <g-master name="evaluators"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              modalWidth="70%"
              ref="master"
              @action="masterAction"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Días reconocidos')">
              <a-input-number :min="0"  v-bind="fiOptions"
                              style="width: 100%"
                              v-decorator="['days_recognised', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Fecha recibido cliente')">
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD HH:mm:ss"
                             v-decorator="['date_rep', { rules: [{ required: false }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Fecha grabacion del sistema')">
              <a-date-picker style="width: 100%"
                             type="date"
                             disabled
                             valueFormat="Y-MM-DD HH:mm:ss"
                             v-decorator="['date_save_sys', { rules: [{ required: false }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Fecha de radicado')">
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD HH:mm:ss"
                             v-decorator="['date_filing', { rules: [{ required: false }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Número de radicación')">
              <a-input-number v-bind="fiOptions"
                              style="width: 100%"
                              v-decorator="['num_filing', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Comentarios')">
              <a-textarea autoSize
                          v-decorator="['comments', { rules: [{ required: false}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Fecha de pago')">
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD HH:mm:ss"
                             v-decorator="['date_pay', { rules: [{ required: false }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
              <g-dropdown v-bind="fiOptions"
                          endpoint="hierarchy_lookup"
                          :has-feedback="false"
                          :formItemConfig="fiOptions"
                          :decorator="['status', { initialValue: 'RAD',rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="estado"
                          :label="$t('Estado')"
              >
              </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown v-bind="fiOptions"
                          :disabled="disabledNoPag"
                          endpoint="ent_type"
                          :has-feedback="false"
                          :formItemConfig="fiOptions"
                          :decorator="['id_ent', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                        :label="$t('Entidad pagadora')"
            >
            </g-dropdown>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Valor reconocido')">
              <a-input-number :min="0" :max="999999999" v-bind="fiOptions"
                              style="width: 100%"
                              :disabled="disabledNoPag"
                              v-decorator="['vlr_recognised', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Ibc empleado')">
              <a-input
                style="width: 100%"
                :disabled="disabledNoPag"
                v-decorator="['ibc_emp', { rules: [{ required: false }]}]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Ibc cliente')">
              <a-input
                style="width: 100%"
                :disabled="disabledNoPag"
                v-decorator="['ibc_client', { rules: [{ required: false }]}]"/>
            </a-form-item>
          </a-col>

        </a-row>
      </template>
    </g-master>

  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['absen'],
    async mounted () {
      this.httpClient = new HttpUtil()
      let result = await this.getValorIBCEmpCli(this.absen.abs_id, this.absen.abs_type)
      this.valor_ibc_emp_cli = result.data
    },
    data () {
      return {
        disabledNoPag: false,
        sysDate: new Date(),
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        estado: {h_lookup_type: 'ESTADO_ABSEN_GESTION', use_code: true},
        tipoEntidadSeleccionada: {},
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        master: {
          endpoint: 'absen_gestion',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Días reconocidos', dataIndex: 'days_recognised', sorter: true},
              {title: 'Fecha recibido cliente', dataIndex: 'date_rep_desc', sorter: true},
              {title: 'Fecha grabación sistema', dataIndex: 'date_save_sys_desc', sorter: true},
              {title: 'Fecha de radicado', dataIndex: 'date_filing_desc', sorter: true},
              {title: 'Número de radicación', dataIndex: 'num_filing', sorter: true},
              {title: 'Comentarios', dataIndex: 'comments', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true},
              {title: 'Fecha de pago', dataIndex: 'date_pay_desc', sorter: true},
              {title: 'Valor reconocido', dataIndex: 'vlr_recognised', sorter: true},
              {title: 'Ibc empleado', dataIndex: 'ibc_emp', sorter: true},
              {title: 'Ibc cliente', dataIndex: 'ibc_client', sorter: true},
              {title: 'ID entidad pagadora', dataIndex: 'id_entidad', sorter: true},
              {title: 'Entidad pagadora', dataIndex: 'ent_name', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'days_recognised'},
            {name: 'date_rep'},
            {name: 'date_save_sys'},
            {name: 'date_filing'},
            {name: 'num_filing'},
            {name: 'comments'},
            {name: 'status'},
            {name: 'date_pay'},
            {name: 'vlr_recognised'},
            {name: 'ibc_emp'},
            {name: 'ibc_client'},
            {name: 'id_ent'}
          ],
          valor_ibc_emp_cli: {}
        }

      }
    },
    methods: {
      masterAction (action) {
        let isEdit = action.action === 'masterEdit'
        if (action.action === 'masterCreate' || isEdit) {
          const fecha = moment(this.sysDate).format('YYYY-MM-DD HH:mm:ss')
          let idEnt = this.absen.legal_entity_id
          if (isEdit) {
            idEnt = action.record.id_ent
          }
          setTimeout(() => {
            this.$refs.master && this.$refs.master.modal.form.setFieldsValue({
              id_ent: idEnt,
              vlr_recognised: this.valor_ibc_emp_cli['valor_rec_cartera'],
              ibc_emp: this.valor_ibc_emp_cli['ibc_empleado'],
              days_recognised: this.valor_ibc_emp_cli['dias_cartera'],
              date_save_sys: fecha
            })
          }, 300)
        }

        switch (action.action) {
          case 'masterEdit':
            if (this.$getConfigValue('EDITAR_CAMPOS_RECUPERACION_CARTERA', 'NO') === 'SI') {
              this.disabledNoPag = false
            } else {
              this.disabledNoPag = action.record.status_desc === 'PAGADO'
            }
            break
        }
      },
      async getValorIBCEmpCli (idAusen, absType) {
        let result = await this.httpClient.getInstance().post('absen_gestion_valor_ib_emp_cli', {
          p_id_ausen: idAusen,
          p_tipo: absType
        })
        return result
      }
    },
    computed: {
      parentData () {
        return {
          id_absen: this.absen.abs_id
        }
      }
    },
    watch: {
      'absen.abs_id': async function () {
        console.log(this.absen)
        let result = await this.getValorIBCEmpCli(this.absen.abs_id, this.absen.abs_type)
        this.valor_ibc_emp_cli = result.data
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/AbsenGestion.vue